import { useQuery } from '@apollo/client'
import { VIDEOS_RECOMMENDED } from '../../../graphql-client/Queries'
import VideoCard from '../../home/home_right/videoCard/VideoCard'
import React from 'react'
import PlayVideoList from '../playVideoList/PlayVideoList'
export default React.memo(function NextVideo(props) {
    const {loading, error, data}= useQuery(VIDEOS_RECOMMENDED);
    if(loading) return <p>loading...</p>;
    if (error) return <p>Error! {error.message}</p>; 
    
    return (
        <>
        
        <div className="col-xl-4 col-lg-4 col-md-4" >
                <PlayVideoList 
                // videoListId={props.videoListId}
                ></PlayVideoList>
            <div className='nextVideo1 ms-2 ps-2 ' > 
                <h5 className='m-1 p-1 sticky-header'>Học liệu phổ biến khác</h5>
                {data.videosRecommended.map((video)=>{                     
                    return (                                  
                        <VideoCard
                            key={video.id}
                            title ={video.title}
                            username={video.user.username}
                            date={video.createdAt}
                            view={video.countView}
                            like={video.countLike}
                            videoId={video.id}
                            thumbnail={video.thumbnail}
                            avatarUser={video.user.avatar}
                            idUser={video.user.id}
                            document={video.document}
                            nextVideo={true}
                        >
                        </VideoCard>
                    )
                })}
            </div>
        </div>
        </>
    )
})
